<app-tabla
  [totalCount]="totalCount"
  [datos]="datos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonCrear"
  [exportar]="botonesExportar"
  [filtros]="filtros"
  [showHijos]="historico"
  [emptyState]="{
    title: historico ? 'Sin emergencias cerradas' : 'Sin emergencias activas',
    subtitle: 'Probá cambiando los filtros o la búsqueda',
  }"
></app-tabla>
